import { createSlice } from "@reduxjs/toolkit";
import { getUserData, removeCookie } from "../utility/utils";
import { decodeToken } from "../utility/jwt.utils";
import { setUserDataOnLocalStorage } from "../utility/authHelper";

export const authSlice = createSlice({
    name: "authentication",
    initialState: {
        userData: getUserData(),
        accessToken: localStorage.getItem("accessToken") || "",
    },
    reducers: {
        handleLogin: (state, action) => {
            state.userData = action.payload;
            state.accessToken = action.payload.token?.accessToken;
            decodeToken(action.payload.token?.accessToken);
            setUserDataOnLocalStorage(state.userData);
            localStorage.setItem(
                "accessToken",
                action.payload.token?.accessToken
            );
        },
        handleLogout: (state) => {
            state.userData = {};
            state.accessToken = null;
            localStorage.removeItem("userData");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user-permission-timestamp");
            //removeCookie("X-ADFS-Token");
        },
    },
});

export const { handleLogin, handleLogout } = authSlice.actions;

export default authSlice.reducer;
